import { useState } from "react";
import axios from 'axios'
import "@fontsource/roboto";
import credomem_img from './chat/credomem.png';
import retvis_img from './chat/retvis.png';
import newvis_img from './chat/retvis.png';
import hand_img from './chat/hand.png';
import flora_icon_img from './chat/flora_icon.png';
import message_img from './chat/message.png';
import flora3_img from './chat/flora_3.png';
import credoletter_img from './chat/credoletter.svg';
import minus_img from './chat/minus.png';
import cross_img from './chat/cross.png';
import flora_gif_img from './chat/flora_gif_mobile.gif';
import topnav_img from './chat/topnav.png';
import botchat_img from './chat/bot_chat.png';
import typing_img from './chat/typing.gif';
import { useIdleTimer } from 'react-idle-timer' 

function Mobile() {
  // eslint-disable-next-line
  const [sender, setsender] = useState<any>(Math.floor(Math.random()*90000) + 10000)
  const [screenSelected, setScreenSelected] = useState(1)
  const [visitorStatus, setVisitorStatus] = useState(0)
  const [visitorEmail, setVisitorEmail] = useState('')
  const [visitorPhoneNo, setVisitorPhoneNo] = useState('')
  const [compArr, setCompArr] = useState<any>([])
  const [textInput, setTextInput] = useState('')
  const [multiButton, setMultiButton] = useState<any>([])
  // eslint-disable-next-line
  const [drflow, setdrflow] = useState<any>({})
  var _ = require('underscore')
  const onPrompt = () => {
    //console.log('onprompt')
 }

 const onIdle = () => {
   //console.log('idle')
   apicall('/terminate',sender)
   alert('Session Expired')
   window.location.reload();
 }

 const onActive = (event: any) => {
   //console.log('active')
 }

 const onAction = (event: any) => {
   //console.log('action')
 }
 // eslint-disable-next-line
 const {
 } = useIdleTimer({
   onPrompt,
   onIdle,
   onActive,
   onAction,
   timeout: 1000 * 60 * 1,
   promptTimeout: 0,
   events: [
     'mousemove',
     'keydown',
     'wheel',
     'DOMMouseScroll',
     'mousewheel',
     'mousedown',
     'touchstart',
     'touchmove',
     'MSPointerDown',
     'MSPointerMove',
     'visibilitychange'
   ],
   immediateEvents: [],
   debounce: 0,
   throttle: 0,
   eventsThrottle: 200,
   element: document,
   startOnMount: true,
   startManually: false,
   stopOnIdle: false,
   crossTab: false,
   name: 'idle-timer',
   syncTimers: 0,
   leaderElection: false
 })
 
const Send = (props:{text:any}) =>
{
  return(
    <>
   <div  style={{display:'flex',flexDirection:'row',minWidth:'50vw',maxWidth:'50vw', backgroundColor:'white',marginLeft:'auto',marginRight:'3vw',marginTop:'3vw'}}>
   <div style={{backgroundColor:'#DBE4F6',color:'black',fontWeight:'normal',fontSize:'4vw',fontFamily:'roboto',maxWidth:'50vw',borderRadius:'3vw 3vw 0vw 3vw',lineHeight:'3.5vh',padding:'2vw',marginLeft:'auto',overflow:'hidden',wordBreak:'break-word'}}>{(props.text.includes('[')?JSON.parse(props.text).join():props.text)}</div> 
    </div>
    </>
  )
}

function delay(setVal:any,val:any)
{
  setTimeout ( function() {
    setVal(val)
  }, 1000);
}

const DelayComp = () =>
{
  return(
    <>
          <div style={{display:'flex',flexDirection:'row',minWidth:'60vw',maxWidth:'60vw', backgroundColor:'white',marginLeft:'1vw',marginRight:'3vw',marginTop:'3vw',}}>
    <div style={{height:'10vw',width:'10vw'}}><img src={botchat_img} alt='' height={undefined} width={undefined}></img></div>
             <div style={{backgroundColor:'rgb(251, 231, 230)',color:'black',fontWeight:'normal',fontSize:'4vw',fontFamily:'roboto',maxWidth:'70vw',borderRadius:'3vw 3vw 3vw 0vw',lineHeight:'3.5vh',padding:'2vw',marginLeft:'2vw'}}><img src={typing_img} alt='' height='8' width='40'></img></div>
         </div>
    </>
  )
}

const ReceiveText = (props:{text:string,iteration:number,bot:string,sender:any}) =>
{
  const [textOutput, setTextOutput] = useState('loading')
  delay(setTextOutput,props['bot'])
  return(
    <>
    {textOutput==='loading'?<DelayComp/>:
        <div style={{display:'flex',flexDirection:'row',minWidth:'60vw',maxWidth:'60vw', backgroundColor:'white',marginLeft:'1vw',marginRight:'3vw',marginTop:'3vw',}}>
    <div style={{height:'10vw',width:'10vw'}}><img src={botchat_img} alt='' height={undefined} width={undefined}></img></div>
             <div style={{backgroundColor:'rgb(251, 231, 230)',color:'black',fontWeight:'normal',fontSize:'4vw',fontFamily:'roboto',maxWidth:'70vw',borderRadius:'3vw 3vw 3vw 0vw',lineHeight:'3.5vh',padding:'2vw',marginLeft:'2vw'}}>{textOutput.includes('https://credo.health/contact/') || textOutput.includes('https://www.credo.health/contact/')?<div>Please click this link [Contact Details]{'\n'}<a href={'https://credo.health/contact/'} rel='noopener'>https://credo.health/contact/</a></div>:textOutput.includes('https://outlook.office365.com/owa/calendar/Bookyourconsultation@credo.health/bookings/')?<span>Please click this link [Book Appointments]{'\n'}<a href={'https://outlook.office365.com/owa/calendar/Bookyourconsultation@credo.health/bookings/'}  style={{wordBreak:'break-word'}} rel='noopener'>https://outlook.office365.com/owa/calendar/Bookyourconsultation@credo.health/bookings/</a></span>:textOutput}</div>
         </div>
    }
    </>
  )
}

const ReceiveButtonUni = (props:{text:string,iteration:number,bot:string,drflow:any,payload:any,sender:any}) =>
{
  // eslint-disable-next-line
  const [textOutput, setTextOutput] = useState<any>('receiver -- loading...')
  const [buttonArr, setButtonArr] = useState<any>([])
  delay(setButtonArr,props['bot'])
  function submit(payload:any,title:any,drflow:any)
  {
   if(payload==="/program_no1{'otherprogram':'No'}"&&props.drflow.bp===2)
   {
     apicall("/eligible{'otherprogram':'No'}",props.sender,null,title)
   }
   else if(payload==="/program_no2{'otherprogram':'No'}"&&props.drflow.bp===2)
   {
    apicall("/DRB{'otherprogram':'No'}",props.sender,null,title)
   }
   else if((payload==="/program_no1{'otherprogram':'No'}"||payload==="/program_no2{'otherprogram':'No'}")&&props.drflow.bp===3)
   {
    apicall('/otpform',props.sender,null,title)
   }
   else if((payload==="/program_no1{'otherprogram':'No'}"||payload==="/program_no2{'otherprogram':'No'}")&&props.drflow.bp===2)
   {
    apicall("/eligible{'otherprogram':'No'}",props.sender,null,title)
   }
   else if((payload==="/program_no1{'otherprogram':'No'}"||payload==="/program_no2{'otherprogram':'No'}")&&props.drflow.bp===1)
   {
    apicall("/DRB{'otherprogram':'No'}",props.sender,null,title)
   }
   else
   {
    apicall(payload,props.sender,null,title,props.drflow)
   }
  }
  const buttonDiv = buttonArr.map((item:any,i:any) => {
    return <div  onClick={()=>submit(item['payload'],item['title'],props.drflow)}     className='buttonuni' key={i} style={{border:'2px solid rgba(0, 0, 0, 0.2)',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'4vw',marginRight:'2vw',padding:'2vw',fontSize:'4vw'}}>{item['title']}</div>
});
  return(
    <> <div style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'1.1vw',fontFamily:'roboto',marginTop:'1vh'}}>
    {buttonArr.length===0?<DelayComp/>:
    buttonDiv}
    </div>
    </>
  )
}

const ReceiveButtonMulti = (props:{text:string,iteration:number,bot:string,drflow:any, payload:string,setdrflow:any,sender:any}) =>
{
  const [multiInner, setMultiInner] = useState<any>([])
  // eslint-disable-next-line
  const [textOutput, setTextOutput] = useState<any>('receiver -- loading...')
  const [buttonArr, setButtonArr] = useState<any>([])
  delay(setButtonArr,props['bot'])
  function multihandle(title:any,multiInner:any)
  {
    if(Boolean(multiInner.includes("None")) ){
      setMultiInner([title])
      setMultiButton([title])
    }
    else if (Boolean(multiInner.includes(title))){
      const spd = multiInner.filter((x: any) => x!== title);
      setMultiInner(spd)
      setMultiButton(spd)
    }
    else if (title==='Cardiac events (within 6 months)')
    {
      const tempInner = multiInner
      tempInner.push(title)
      const spd = tempInner.filter((x: any) => x!== 'Cardiac events (6 months and above)');
      setMultiInner(spd)
      setMultiButton(spd)
    }
    else if (title==='Cardiac events (6 months and above)')
    {
      const tempInner = multiInner
      tempInner.push(title)
      const spd = tempInner.filter((x: any) => x!== 'Cardiac events (within 6 months)');
      setMultiInner(spd)
      setMultiButton(spd)
    }
    else{
      setMultiInner((oldArr: any)=>[...oldArr,title])
      setMultiButton((oldArr: any)=>[...oldArr,title])
    }
    if(Boolean(title==='All the Above')){
      setMultiInner(['Smartwatch','Body Composition Monitor','Blood Pressure Monitor','All the Above'])
      setMultiButton(['Smartwatch','Body Composition Monitor','Blood Pressure Monitor','All the Above'])
    }
    if(Boolean(title==='None')){
      setMultiInner(['None'])
      setMultiButton(['None'])
    }
  }
 
  function multisubmit(setdrflow:any)
  {
    if(multiInner.includes('Smartwatch')||multiInner.includes('Blood Pressure Monitor')||multiInner.includes('Body Composition Monitor'))
    {
      apicall(props.payload,props.sender,(multiInner),JSON.stringify(multiInner))
    }
    else{ if(multiInner.includes('Blood Pressure'))
    {
      apicall('/age',props.sender,(multiInner),JSON.stringify(multiInner))
    }
    if(multiInner.includes('Thyroid')||multiInner.includes('Cardio Vascular Disease')||multiInner.includes('Others'))
    {
      apicall('/otpform',props.sender,(multiInner),JSON.stringify(multiInner))
    }
    else{}
    if(multiInner.includes('Psychiatric and neurological conditions')||multiInner.includes("Cardiac events (within 6 months)")||multiInner.includes('Cardiovascular Disease')||multiInner.includes('Bariatric surgery'))
    {
      setdrflow({bp:3})
      apicall(props.payload,props.sender,(multiInner),JSON.stringify(multiInner),{bp:3})
    }
    else if(multiInner.includes('IBS')||multiInner.includes('Kidney disease')||multiInner.includes('Cancer')||multiInner.includes('HIV'))
    {
        setdrflow({bp:1})
        apicall(props.payload,props.sender,(multiInner),JSON.stringify(multiInner),{bp:1})
    }
    else if(multiInner.includes('Cardiac events (6 months and above)')||multiInner.includes('BP')||multiInner.includes('None'))
    {
      setdrflow({bp:2})
      apicall(props.payload,props.sender,(multiInner),JSON.stringify(multiInner),{bp:2})
    }
    else{}}
  }
  const buttonDiv = buttonArr.map((item:any,i:any) => {
    return <div   onClick={()=>multihandle(item.title,multiInner)}   key={i} style={{border:'2px solid rgba(0, 0, 0, 0.2)',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'4vw',marginRight:'2vw',padding:'2vw',backgroundColor:`${Boolean(multiInner.includes(item.title))?'#FA7837':'white'}`,fontSize:'4vw',color:`${Boolean(multiInner.includes(item.title))?'white':'black'}`}}>{item['title']}</div>
});
  return(
    <> <div style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'1.1vw',fontFamily:'roboto',marginTop:'1vh'}}>
    {buttonArr.length===0?<DelayComp/>:
    <>{ buttonDiv}<div onClick={()=>multisubmit(props.setdrflow)}  style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'4.5vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>Submit</div>
    </>
    }
    </div>
    </>
  )
}

const ReceiveForm = (props:{text:string,iteration:number,bot:string,payload:string,valueInput:any,sender:any}) =>
{
  const [textOutput, setTextOutput] = useState<any>('loading')
  delay(setTextOutput,props['bot'])
  const PersonalForm = () =>
  {
    const [name,setName]=useState('')
    const [phone,setPhone]=useState('')
    var formData:any = {name:name,phone:phone}
    function submit()
    {
      if(name.length===0||phone.length===0||phone.length!==10){alert('Enter Valid Data')}
      else{apicall(props.payload,props.sender,formData,'Personal Form Submitted')}
    }
    return(
      <>
  {textOutput==='loading'?<DelayComp/>:<div>
      <div style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'1.1vw',fontFamily:'roboto',border:'3px solid #C0C0C0',marginTop:'3vw',borderRadius:'2vw'}}>
        <div style={{border:'0px solid rgba(0, 0, 0, 0.2)',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',fontWeight:'600',fontSize:'4vw'}}>Personal Information</div>
        <div style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Name'} onChange={(e:any)=>setName(e.target.value)} ></input></div>
        <div style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Phone Number'}  onChange={(e:any)=>setPhone(e.target.value)} ></input></div>
        <div  onClick={submit} style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'4.5vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>Submit</div>
      </div>
      </div>
       } 
      </>
    )
  }

  const DeviceForm = () =>
  {
    const [device_name,setDeviceName]=useState('')
    const [device_number,setDeviceNumber]=useState('')
    var formData:any = {device_name:device_name,device_number:device_number}
    const deviceArr=['Smartwatch','Body Composition Monitor','Blood Pressure Monitor']
    function submit()
    {
      if(device_name.length===0||device_number.length===0){alert('Enter Valid Data')}
      else{
        apicall(props.payload,props.sender,formData,'Device Form Submitted')}
    }
   const deviceHtml= _.intersection(deviceArr,JSON.parse(props.valueInput)).map((item:any,i:any)=>{
      return(
        <>
        <div key={i}>
         <div style={{border:'0px solid rgba(0, 0, 0, 0.2)',borderRadius:'0.5vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'1vw',marginRight:'1vw',fontWeight:'600'}}> ( {item} ) Information</div>
         <div style={{border:'3px solid #C0C0C0',borderRadius:'0.5vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'1vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'15vw',border:'0px',outline:'none',fontSize:'1.1vw',height:'3vh'}} placeholder={'Device Name'}  onChange={(e:any)=>setDeviceName(e.target.value)} ></input></div>
        <div style={{border:'3px solid #C0C0C0',borderRadius:'0.5vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'1vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'15vw',border:'0px',outline:'none',fontSize:'1.1vw',height:'3vh'}} placeholder={'Device Number'} onChange={(e:any)=>setDeviceNumber(e.target.value)}  ></input></div>
        </div> </>
      )
    })
    return(
      <>
        {textOutput==='loading'?<DelayComp/>:<div>
      <div style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'1.1vw',fontFamily:'roboto',border:'3px solid #C0C0C0',marginTop:'3vw',borderRadius:'2vw'}}>
       {deviceHtml}
       {props.valueInput.length===0||props.valueInput.includes('None')?null: <div  onClick={submit} style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'4.5vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>Submit</div>}
      </div>
      </div>
       } 
      </>
    )
  }

  const DemoForm = () =>
  {
    const [name,setName]=useState('')
    const [gender,setGender]=useState('')
    const [age,setAge]=useState('')
    const [mobile,setMobile]=useState('')
    const [email,setEmail]=useState('')
    var formData:any = {name:name,gender:gender,age:age,mobile:mobile,email:email,}
    function submit()
    {
      if(name.length===0||gender.length===0||age.length===0||mobile.length===0||email.length===0){alert('Enter Valid Data')}
      else{apicall(props.payload,props.sender,formData,'Demographic Form Submitted')}
    }
    return(
      <>
     {textOutput==='loading'?<DelayComp/>:<div>
      <div style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'1.1vw',fontFamily:'roboto',border:'3px solid #C0C0C0',marginTop:'3vw',borderRadius:'2vw'}}>
        <div style={{border:'0px solid rgba(0, 0, 0, 0.2)',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',fontWeight:'600',fontSize:'4vw'}}>Demo Information</div>
        <div style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Full Name'}  onChange={(e:any)=>setName(e.target.value)} ></input></div>
        <div style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Gender'}  onChange={(e:any)=>setGender(e.target.value)} ></input></div>
        <div style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Age'}  onChange={(e:any)=>setAge(e.target.value)} ></input></div>
        <div style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Contact Number'}  onChange={(e:any)=>setMobile(e.target.value)} ></input></div>
        <div style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Email ID'}  onChange={(e:any)=>setEmail(e.target.value)} ></input></div>
        <div  onClick={submit} style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'4.5vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>Submit</div>
      </div>
      </div>
  }
      </>
    )
  }

  const OTPForm = () =>
  {
    const[otpState,setOtpState]= useState(0)
    const[phno,setphno] = useState(0)
    const[otpval,setotpval]=useState(0)
    const [otptext,setotptext] = useState('Generate OTP')
    function submit()
    {
      if(otpState===0){setOtpState(1); otpapicall1(phno);setotptext('Verify OTP')}
      if(otpState===1){
        //var otp_url='https://dev-care-api.credo.health'
        var otp_url='https://api.credo.health'
         let url = otp_url+'/api/v1/SMSGateway/VerifyNonMemberOTP?PhoneNumber='+phno+'&OTP='+otpval;
         var data;
         axios.post(url, {
             withCredentials: true,
         })
         .then(res => {
           data=res.data.code 
           if(data===200)
           {
            setOtpState(2); apicall(props.payload,props.sender,null,'OTP Verified');setotptext('OTP Verified')
           }
           else
           {
            alert('Invalid OTP')
           }
         })
         .catch()
   
        }
   }
    return(
        <>
      {textOutput==='loading'?<DelayComp/>:<div>
      <div style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'1.1vw',fontFamily:'roboto',border:'3px solid #C0C0C0',marginTop:'3vw',borderRadius:'2vw'}}>
        <div style={{border:'0px solid rgba(0, 0, 0, 0.2)',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',fontWeight:'600',fontSize:'4vw'}}>Personal Form</div>
        <div style={{ border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Phone Number'} onChange={(e:any)=>setphno(e.target.value)}></input></div>
                <div style={{display:`${otpState===0?'none':'flex'}`,border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Enter OTP'} onChange={(e:any)=>setotpval(e.target.value)}></input></div>
        <div  onClick={submit} style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'4.5vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>{otptext}</div>
      </div>
      </div>
  }
      </>
    )
  }

  const InsulinForm = () =>
  {
    const [insulinname,setInsulinName]=useState('')
    const [insulinunit,setInsulinUnit]=useState('')
    const [insulinfreq,setInsulinFreq]=useState('')
    var formData:any = {insulinname:insulinname,insulinunit:insulinunit,insulinfreq:insulinfreq}
    function submit()
    {
      if(insulinname.length===0||insulinunit.length===0||insulinfreq.length===0){alert('Enter Valid Data')}
      else{apicall(props.payload,props.sender,formData,'Insulin Form Submitted')}
    }
    return(
      <>
      {textOutput==='loading'?<DelayComp/>:<div>
      <div style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'1.1vw',fontFamily:'roboto',border:'3px solid #C0C0C0',marginTop:'3vw',borderRadius:'2vw'}}>
        <div style={{border:'0px solid rgba(0, 0, 0, 0.2)',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',fontWeight:'600',fontSize:'4vw'}}>Insulin Information</div>
        <div style={{ border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Insulin Name'} onChange={(e:any)=>setInsulinName(e.target.value)}></input></div>
        <div style={{ border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Insulin Unit'} onChange={(e:any)=>setInsulinUnit(e.target.value)}></input></div>
        <div style={{ border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Insulin Freq'} onChange={(e:any)=>setInsulinFreq(e.target.value)}></input></div>
        <div  onClick={submit} style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'4.5vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>Submit</div>
      </div>
      </div>
  }
      </>
    )
  }

  const BpForm = () =>
  {
    const [bpvalue,setbpvalue]=useState('')
    function submit()
    {
      if(bpvalue.length===0){alert('Enter Valid Data')}
      else{apicall(bpvalue,props.sender,null,bpvalue)}
    }
    return(
      <>
      {textOutput==='loading'?<DelayComp/>:<div>
          <div style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'1.1vw',fontFamily:'roboto',border:'3px solid #C0C0C0',marginTop:'3vw',borderRadius:'2vw'}}>
            <div style={{border:'0px solid rgba(0, 0, 0, 0.2)',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',fontWeight:'600',fontSize:'4vw'}}>BP Information</div>
            <div style={{ border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'120/80'} onChange={(e:any)=>setbpvalue(e.target.value)} ></input></div>
            <div  onClick={submit} style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'4.5vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>Submit</div>
          </div>
          </div>
      }
          </>
    )
  }

  const ProgramForm = () =>
  {   
    const [nameprogram,setnameprogram]=useState('')
    const [nameprovider,setnameprovider]=useState('')
    const [durationprogram,setdurationprogram]=useState('')
    const [yearenroled,setyearenroled]=useState('')
    var formdata:any={nameprogram:nameprogram,nameprovider:nameprovider,durationprogram:durationprogram,yearenroled:yearenroled}
  function submit()
  {
    if(nameprogram.length===0||nameprovider.length===0||durationprogram.length===0||yearenroled.length===0){alert('Enter Valid Data')}
    else{      
    apicall(props.payload,props.sender,formdata,'Program Form Submitted')
   }
     
  }
    return(
      <>
  {textOutput==='loading'?<DelayComp/>:<div>
      <div style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'1.1vw',fontFamily:'roboto',border:'3px solid #C0C0C0',marginTop:'3vw',borderRadius:'2vw'}}>
        <div style={{border:'0px solid rgba(0, 0, 0, 0.2)',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',fontWeight:'600',fontSize:'4vw'}}>Program Form</div>
        <div style={{ border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Program Name'} onChange={(e:any)=>setnameprogram(e.target.value)}></input></div>
        <div style={{ border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Provider Name'} onChange={(e:any)=>setnameprovider(e.target.value)}></input></div>
        <div style={{ border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Program Duration'} onChange={(e:any)=>setdurationprogram(e.target.value)}></input></div>
        <div style={{ border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'Years Enrolled'} onChange={(e:any)=>setyearenroled(e.target.value)}></input></div>
        <div  onClick={submit} style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'4.5vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>Submit</div>
      </div>
      </div>
  }
      </>
    )
  }
  return(
    <>
    <div>
    {textOutput['attribute_name']==='personal'?<PersonalForm/>:null}
    {textOutput['attribute_name']==='device'?<DeviceForm/>:null}
    {textOutput['attribute_name']==='demo'?<DemoForm/>:null}
    {textOutput['attribute_name']==='otp'?<OTPForm/>:null}
    {textOutput['attribute_name']==='insulin'?<InsulinForm/>:null}
    {textOutput['attribute_name']==='BPreading'?<BpForm/>:null}
    {textOutput['attribute_name']==='program'?<ProgramForm/>:null}
    </div>
    </>
  )
}

const ReceiveYears = (props:{text:string,iteration:number,bot:string,payload:string,sender:any}) =>
{
  const [yearInput, setYearInput] = useState('')
  const [dataArr, setDataArr] = useState<any>([])
  delay(setDataArr,props['bot'])
  return(
    <>    {dataArr.length===0?<DelayComp/>:<div>
    <div style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'4vw',fontFamily:'roboto',border:'3px solid #C0C0C0',marginTop:'3vw',borderRadius:'0.5vw'}}>
      <div style={{border:'0px solid rgba(0, 0, 0, 0.2)',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',fontWeight:'600',fontSize:'4vw'}}>Enter Year</div>
      <div style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw'}}><input type='text' style={{minWidth:'55vw',border:'0px',outline:'none',fontSize:'4vw',height:'4vh'}} placeholder={'5 Years'} onChange={(e:any)=>setYearInput(e.target.value)} ></input></div>
      <div  onClick={()=>yearInput===''?alert('Enter Valid Data'):apicall(yearInput.includes('year')?yearInput:yearInput+' Year',props.sender,null,yearInput.includes('year')?yearInput:yearInput+' Year')} style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'4.5vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>Submit</div>
    </div>
    </div>
}
    </>
  )
}

const ReceiveDate = (props:{text:string,iteration:number,bot:string,payload:string,sender:any}) =>
{
  const [yearDate, setDateInput] = useState('')
  const [dataArr, setDataArr] = useState<any>([])
  delay(setDataArr,props['bot'])
  return(
    <>
    {dataArr.length===0?<DelayComp/>: <div  style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'4vw',fontFamily:'roboto',border:'3px solid #C0C0C0',marginTop:'3vw',borderRadius:'2vw'}}>
      <div style={{border:'0px solid rgba(0, 0, 0, 0.2)',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',fontWeight:'600',fontSize:'4vw'}}>Date</div>
      <div style={{border:'3px solid #C0C0C0',borderRadius:'0.5vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'1vw',marginRight:'1vw',marginLeft:'1vw',display:'flex',flexDirection:'row'}}><div style={{fontSize:'1.1vw',marginLeft:'0.75vw',marginRight:'0.75vw',color:'#FF6702'}}><input style={{minWidth:'53vw',paddingRight:'0.5vw',outline:'none',border:'0px',height:'5vh',fontSize:'4vw'}}  type="date" max={new Date().toISOString().slice(0, 10)} onChange={(e:any)=>setDateInput(e.target.value)} ></input></div></div>
     <div  onClick={()=>yearDate===''?alert('Enter Valid Data'):apicall(yearDate.split('-')[2]+'-'+yearDate.split('-')[1]+'-'+yearDate.split('-')[0],props.sender,null,yearDate.split('-')[2]+'-'+yearDate.split('-')[1]+'-'+yearDate.split('-')[0])} style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'4.5vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>Submit</div>
      </div>
 }
     </>
  )
}

const ReceiveBmiHeight = (props:{text:string,iteration:number,bot:string,payload:string,sender:any}) =>
{
  const [heightInput, setHeightInput] = useState('')
  const [dataArr, setDataArr] = useState<any>([])
  delay(setDataArr,props['bot'])
  return(
    <>
    {dataArr.length===0?<DelayComp/>: <div  style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'4vw',fontFamily:'roboto',border:'3px solid #C0C0C0',marginTop:'3vw',borderRadius:'0.5vw'}}>
     <div style={{border:'0px solid rgba(0, 0, 0, 0.2)',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',fontWeight:'600',fontSize:'4vw'}}>Height</div>
     <div style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',display:'flex',flexDirection:'row'}}><div style={{fontSize:'1.1vw',marginLeft:'0.75vw',marginRight:'0.75vw',color:'#FF6702'}}><input style={{minWidth:'13vw',paddingRight:'0.5vw',outline:'none',border:'0px',height:'3vh',fontSize:'4vw'}} placeholder='155 Cm'  type="text" onChange={(e:any)=>setHeightInput
      (e.target.value)}></input></div></div>
    <div  onClick={()=>(/[a-z]/.test(heightInput) || heightInput===''||parseInt(heightInput)<120||parseInt(heightInput)>240)?alert('Enter Valid Data'):apicall(heightInput.includes('cm')?heightInput:heightInput+' Cm',props.sender,null,heightInput.includes('cm')?heightInput:heightInput+' Cm')} style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'4.5vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>Submit</div>
     </div>
}
    </>
  )
}

const ReceiveBmiWeight = (props:{text:string,iteration:number,bot:string,payload:string,sender:any}) =>
{
  const [weightInput, setWeightInput] = useState('')
  const [dataArr, setDataArr] = useState<any>([])
  delay(setDataArr,props['bot'])
  return(
    <>
    {dataArr.length===0?<DelayComp/>: <div  style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'4vw',fontFamily:'roboto',border:'3px solid #C0C0C0',marginTop:'3vw',borderRadius:'2vw'}}>
      <div style={{border:'0px solid rgba(0, 0, 0, 0.2)',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',fontWeight:'600',fontSize:'4vw'}}>Weight</div>
      <div style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'1vw',marginRight:'1vw',marginLeft:'1vw',display:'flex',flexDirection:'row'}}><div style={{fontSize:'4vw',marginLeft:'0.75vw',marginRight:'0.75vw',color:'#FF6702'}}><input style={{minWidth:'13vw',paddingRight:'0.5vw',outline:'none',border:'0px',height:'3vh',fontSize:'4vw'}}  placeholder='65 Kg' type="text" onChange={(e:any)=>setWeightInput(e.target.value)}></input></div></div>
     <div  onClick={()=>/[a-z]/.test(weightInput) || weightInput===''||parseInt(weightInput)<30||parseInt(weightInput)>130?alert('Enter Valid Data'):apicall(weightInput.includes('kg')?weightInput:weightInput+' Kg',props.sender,null,weightInput.includes('kg')?weightInput:weightInput+' Kg')} style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'4.5vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>Submit</div>
      </div>
 }
     </>
  )
}

const ReceiveFile = (props:{text:string,iteration:number,bot:string,payload:string,sender:any}) =>
{
  const [fileInput, setFileInput] = useState('')
  const [dataArr, setDataArr] = useState<any>([])
  delay(setDataArr,props['bot'])
  return(
    <>
   {dataArr.length===0?<DelayComp/>: <div  style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'4vw',fontFamily:'roboto',border:'3px solid #C0C0C0',marginTop:'3vw',borderRadius:'2vw'}}>
     <div style={{border:'0px solid rgba(0, 0, 0, 0.2)',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',fontWeight:'600',fontSize:'4vw'}}>File</div>
     <div style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',display:'flex',flexDirection:'row'}}><div style={{fontSize:'4vw',marginLeft:'0.75vw',marginRight:'0.75vw',color:'#FF6702'}}><input style={{minWidth:'10vw',paddingRight:'0.5vw',outline:'none',border:'0px',height:'3vh',fontSize:'4vw'}}  type="file" onChange={(e:any)=>setFileInput(e.target.value)}></input></div></div>
    <div  onClick={()=>fileInput===''?alert('Enter Valid Data'):apicall('/livesupport',props.sender,null,'File Form Submitted')} style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'4.5vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>Submit</div>
     </div>
}
    </>
  )
}
const ReceiveRating = (props:{text:string,iteration:number,bot:string,payload:string,sender:any}) =>
{
  const [ratingInput, setRatingInput] = useState('')
  // eslint-disable-next-line
  const [textOutput, setTextOutput] = useState<any>('receiver -- loading...')
  const [dataArr, setDataArr] = useState<any>([])
  delay(setDataArr,props['bot'])
  var star_arr=[]
  for(let k=1;k<=5;k++)
  {
      star_arr.push(<div key={k} onClick={()=>setRatingInput(String(k+1))}  style={{fontSize:'2vw',marginLeft:'0.75vw',marginRight:'0.75vw',color:'#FF6702'}}>{2<k?('\u2606'):('\u2605')}</div>)
  }
  return(
    <>
    {dataArr.length===0?<DelayComp/>:<div  style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'4vw',fontFamily:'roboto',border:'3px solid #C0C0C0',marginTop:'3vw',borderRadius:'2vw'}}>
        <div style={{border:'0px solid rgba(0, 0, 0, 0.2)',borderRadius:'0.5vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',fontWeight:'600',fontSize:'4vw'}}>Rating</div>
        <div style={{border:'3px solid #C0C0C0',borderRadius:'0.5vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'1vw',marginRight:'1vw',marginLeft:'1vw',display:'flex',flexDirection:'row'}}>{star_arr}</div>
       <div onClick={()=>ratingInput===''?alert('Enter Valid Data'):apicall(ratingInput,props.sender,null,ratingInput)} style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'4.5vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>Submit</div>
        </div>
   }
       </>
  )
}

const ReceiveBlob = (props:{text:string,iteration:number,bot:string,payload:string,sender:any}) =>
{
  const [dataArr, setDataArr] = useState<any>([])
  delay(setDataArr,props['bot'])
  return(
    <>
    {dataArr.length===0?<DelayComp/>:<div  style={{display:'flex',flexFlow:'wrap',marginLeft:'1vw',marginRight:'1vw',fontSize:'1.1vw',fontFamily:'roboto',border:'3px solid #C0C0C0',marginTop:'3vw',borderRadius:'0.5vw'}}>
        <div style={{border:'3px solid #C0C0C0',borderRadius:'3vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',display:'flex',flexDirection:'row'}}><img src={props.bot} alt='' height={300} width={300}></img></div>
       <div onClick={()=>apicall(props.payload,props.sender,null,'')} style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'3vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>Back</div>
       <div onClick={()=>apicall('/credo',props.sender,null,'Continue with Credo Chat')} style={{border:'3px solid #C0C0C0',borderRadius:'2vw',paddingLeft:'3vw',paddingRight:'1vw',marginTop:'2vw',marginRight:'1vw',marginLeft:'1vw',marginBottom:'2vw',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'65vw',textAlign:'center',height:'3vh',alignItems:'center',display:'flex',justifyContent:'center',fontSize:'4vw'}}>Main Menu</div>
        </div>
   }
       </>
  )
}

function otpapicall1(phno:any)
{
  //var otp_url='https://dev-care-api.credo.health'
  var otp_url='https://api.credo.health'
    let url = otp_url+'/api/v1/SMSGateway/GenerateOTP?PhoneNumber='+phno;
    axios.post(url, {
        withCredentials: true,
    })
    .then(res => {
      // eslint-disable-next-line
      var data=res.data 
    })
    .catch()
}

function receive_fun(textOutput:any,j:any,valueInput:any,drflow:any,sender:any)
{
try
{
  return(
    <>
    <style>
      {
        `
        body {
          font-family: "Roboto";
        }
        `
      }
    </style>
    {textOutput[j]['module']==='text'?<ReceiveText text={textInput} bot={textOutput[j]['text']} iteration={j} sender={sender} />:null}
      {textOutput[j]['module']==='buttonuni'?<ReceiveButtonUni text={textInput} bot={textOutput[j]['text']} payload={textOutput[j]['payload']} iteration={j} drflow={drflow} sender={sender} />:null}
      {textOutput[j]['module']==='buttonmulti'?<ReceiveButtonMulti text={textInput} bot={textOutput[j]['text']} iteration={j} payload={textOutput[j]['payload']} drflow={drflow} setdrflow={setdrflow} sender={sender}  />:null}
      {textOutput[j]['module']==='form'?<ReceiveForm text={textInput} bot={textOutput[j]['text']} payload={textOutput[j]['payload']} iteration={j} valueInput={valueInput} sender={sender} />:null}
      {textOutput[j]['module']==='years'?<ReceiveYears text={textInput} bot={textOutput[j]['text']} payload={textOutput[j]['payload']} iteration={j} sender={sender} />:null}
      {textOutput[j]['module']==='date'?<ReceiveDate text={textInput} bot={textOutput[j]['text']} payload={textOutput[j]['payload']} iteration={j} sender={sender} />:null}
      {textOutput[j]['module']==='bmi_height'?<ReceiveBmiHeight text={textInput} bot={textOutput[j]['text']} payload={textOutput[j]['payload']} iteration={j} sender={sender} />:null}
      {textOutput[j]['module']==='bmi_weight'?<ReceiveBmiWeight text={textInput} bot={textOutput[j]['text']} payload={textOutput[j]['payload']} iteration={j} sender={sender} />:null}
      {textOutput[j]['module']==='file'?<ReceiveFile text={textInput} bot={textOutput[j]['text']} payload={textOutput[j]['payload']} iteration={j} sender={sender} />:null}
      {textOutput[j]['module']==='rating'?<ReceiveRating text={textInput} bot={textOutput[j]['text']} payload={textOutput[j]['payload']} iteration={j} sender={sender} />:null}
      {textOutput[j]['module']==='blob'?<ReceiveBlob text={textInput} bot={textOutput[j]['text']} payload={textOutput[j]['payload']} iteration={j} sender={sender} />:null}
         </>
  )
}
catch(error)
{
}
}

function apicall(textInput:String,sender:Number,metadata=null,valueInput='',drflow={})
{
  setCompArr((oldArr: any)=>[...oldArr,(valueInput!=='')?<Send text={valueInput}/>:null])
  //var url = 'https://ai-api.credo.health/app05/api/chat/test' //8005 - stg
  var url = 'https://ai-api.credo.health/app105/api/chat/test' //8105 - prod
  //var url = 'http://localhost:5005/webhooks/rest/webhook'
  //var url = 'http://localhost:8005/api/chat/test'
  var formData= {
    "sender": sender,
    "message": textInput,
    "metadata": metadata
}
console.log({input:formData})
  axios.post(url, formData)
  .then(res => {
    var textOutput=res.data
    console.log({output:textOutput})
    var textOutJson=[]
    var j = -1;                
    for(var i1=0;i1<textOutput.length;i1++){if(textOutput[i1]['text']){textOutJson.push({text:(textOutput[i1]['text']),module:'text'})}}
    for(var i2=0;i2<textOutput.length;i2++){if(textOutput[i2]['buttons']&&textOutput[textOutput.length-1]['custom']&&textOutput[textOutput.length-1]['custom']['attribute_type']==='buttonuni'){textOutJson.push({text:(textOutput[i2]['buttons']),module:'buttonuni',drflow:drflow})}}
    for(var i3=0;i3<textOutput.length;i3++){if(textOutput[i3]['buttons']&&textOutput[textOutput.length-1]['custom']&&textOutput[textOutput.length-1]['custom']['attribute_type']==='buttonmulti'){textOutJson.push({text:(textOutput[i3]['buttons']),module:'buttonmulti',payload:typeof(textOutput[i3+1]['custom'])=='undefined'?null:textOutput[i3+1]['custom']['attribute_payload']})}}
    for(var i4=0;i4<textOutput.length;i4++){if(textOutput[i4]['custom']&&(textOutput[i4]['custom']['attribute_type']==='form'||textOutput[i4]['custom']['attribute_type']==='BPreading')){textOutJson.push({text:(textOutput[i4]['custom']),module:'form',payload:textOutput[i4]['custom']['attribute_payload'],textInput:textInput,value:valueInput})}}
    for(var i5=0;i5<textOutput.length;i5++){if(textOutput[i5]['custom']&&textOutput[i5]['custom']['attribute_type']==='years'){textOutJson.push({text:(textOutput[i5]['custom']),module:'years',payload:textOutput[i5]['custom']['attribute_payload']})}}
    for(var i6=0;i6<textOutput.length;i6++){if(textOutput[i6]['custom']&&textOutput[i6]['custom']['attribute_type']==='date'){textOutJson.push({text:(textOutput[i6]['custom']),module:'date',payload:textOutput[i6]['custom']['attribute_payload']})}}
    for(var i7=0;i7<textOutput.length;i7++){if(textOutput[i7]['custom']&&textOutput[i7]['custom']['attribute_type']==='bmi_height'){textOutJson.push({text:(textOutput[i7]['custom']),module:'bmi_height',payload:textOutput[i7]['custom']['attribute_payload']})}}
    for(var i8=0;i8<textOutput.length;i8++){if(textOutput[i8]['custom']&&textOutput[i8]['custom']['attribute_type']==='bmi_weight'){textOutJson.push({text:(textOutput[i8]['custom']),module:'bmi_weight',payload:textOutput[i8]['custom']['attribute_payload']})}}
    for(var i9=0;i9<textOutput.length;i9++){if(textOutput[i9]['custom']&&textOutput[i9]['custom']['attribute_type']==='file'){textOutJson.push({text:(textOutput[i9]['custom']),module:'file',payload:textOutput[i9]['custom']['attribute_payload']})}}
    for(var i10=0;i10<textOutput.length;i10++){if(textOutput[i10]['custom']&&textOutput[i10]['custom']['attribute_type']==='rating'){textOutJson.push({text:(textOutput[i10]['custom']),module:'rating',payload:textOutput[i10]['custom']['attribute_payload']})}}
    for(var i11=0;i11<textOutput.length;i11++){if(textOutput[i11]['custom']&&textOutput[i11]['custom']['attribute_type']==='images'){textOutJson.push({text:(textOutput[i11]['custom']['attribute_url']),module:'blob',payload:textOutput[0]['buttons'][0]['payload']})}}   
    function myLoop(textOutJson:any) {        
  setTimeout(function() {  
    j++;   
   setCompArr((oldArr: any)=>[...oldArr,receive_fun(textOutJson,j,valueInput,drflow,sender)])
    if (j<textOutJson.length-1) {          
      myLoop(textOutJson);             
    }       
  }, 1000)
}
myLoop(textOutJson);
  })
  .catch()
}
  return (
    <div  id='credo-chatbot-root' style={{display:'flex',backgroundColor:'white',backgroundSize:'cover',backgroundRepeat:'no-repeat'}}>
      { 
        screenSelected===1?<Screen1 setScreenSelected={setScreenSelected} />:
        screenSelected===2?<Screen2 setScreenSelected={setScreenSelected} apicall = {apicall} sender={sender} />:
        screenSelected===3?<Screen3 setScreenSelected={setScreenSelected} setVisitorStatus={setVisitorStatus}  apicall={apicall} sender={sender} />:
        screenSelected===4?<Screen4 setScreenSelected={setScreenSelected} setVisitorStatus={setVisitorStatus} visitorStatus={visitorStatus} setVisitorEmail={setVisitorEmail} setVisitorPhoneNo={setVisitorPhoneNo} visitorEmail={visitorEmail} visitorPhoneNo={visitorPhoneNo} apicall={apicall} sender={sender}/>:
        screenSelected===5?<Screen5 setScreenSelected={setScreenSelected} setTextInput={setTextInput} textInput={textInput} compArr={compArr} apicall={apicall} sender={sender}/>:
        screenSelected===6?<Screen6 setScreenSelected={setScreenSelected} setTextInput={setTextInput} textInput={textInput} compArr={compArr} apicall={apicall} multiButton={multiButton} setMultiButton={setMultiButton} sender={sender}/>:null
     }
    </div>
  );
}

const MessageIcon = () =>
{
    return(
        <>
         <div  style={{position:'absolute',left:'76vw',top:'87vh', color:'white',cursor:'pointer'}}>
        <img  style={{borderRadius:'0px 0px 0px 0px',width:'19vw', minHeight:'11vh',maxHeight:'11vh'}} src={message_img} alt='' width={'67vw'} height={'67vh'} ></img>
        </div>
       
        </>
    )
}
const NavHeader = (props:{setScreenSelected:any,apicall:any,sender:any}) =>
{
    return(
        <>
        <div ><img style={{borderRadius:'10px 10px 0px 0px',minWidth:'78vw',minHeight:'11vh',marginBottom:'3vh'}} src={topnav_img} alt='' width='100' height='30'></img></div>
        <div ><img style={{borderRadius:'0px 0px 0px 0px',minWidth:'15vw',minHeight:'10vh',left:'8vw',position:'absolute',top:'1vh'}} src={flora3_img} alt='' width='30' height='50'></img></div>
        <div  ><img style={{borderRadius:'0px 0px 0px 0px',minWidth:'30vw',minHeight:'10vh',left:'23vw',position:'absolute',top:'1vh'}} src={credoletter_img} alt='' width='30' height='50'></img></div>
        <div onClick={()=>{props.setScreenSelected(1);props.apicall('/terminate',props.sender)}}  ><img style={{borderRadius:'0px 0px 0px 0px',minWidth:'2.5vw',height:'0.3vh',right:'14vw',position:'absolute',top:'2.5vh',cursor:'pointer'}} src={minus_img} alt='' width='10' height='1'></img></div>
        <div onClick={()=>{props.setScreenSelected(1);props.apicall('/terminate',props.sender)}} ><img style={{borderRadius:'0px 0px 0px 0px',minWidth:'2.5vw',minHeight:'1.5vh',right:'5vw',position:'absolute',top:'1.7vh',cursor:'pointer'}} src={cross_img}  alt='' width='10' height='12'></img></div>   </>
    )
}

const Screen1 = (props:{setScreenSelected:any}) =>
{
  const [hide, setHide] = useState(true)
  return(
    <>
    <div onClick={()=>{props.setScreenSelected(2);}}  style={{visibility: `${Boolean(hide)?'hidden':'visible'}`,position:'absolute',left:'28vw',top:`${'65vh'}`, backgroundColor:'#FFFFFF',cursor:'pointer',minHeight:'23.6vh',minWidth:'60vw',borderRadius:'4vw',boxShadow:'0px 0px 3px 0px black',maxWidth:'18vw',}}>
<div style={{fontFamily:'roboto',fontSize:'4vw',padding:'5vw',lineHeight:1.5,textAlign:'justify'}}>{'We are so glad that you stopped by! Credo Health is the right place if you are looking out to manage your chronic health conditions. Chat with us !'}

</div>
<div style={{border: '0.03vw solid #DEDEDE',maxWidth:'54vw',marginLeft:'4vw'}}></div>
<div style={{color:'#8995AA',fontWeight:'300',fontSize:'1vw',paddingLeft:'1.2vw',paddingTop:'0.3vw',display:'none'}}>Enter your message...</div>
<div style={{marginLeft:'27vw',position:'relative',bottom:'0.25vh'}}><img src={hand_img} alt=''  width={'10vw'} height={'15vh'}></img></div>
        </div>
        <div onClick={()=>setHide(false)}  style={{position:'absolute',left:'75vw',top:'87vh', color:'white',cursor:'pointer'}}>
        <img  style={{borderRadius:'0px 0px 0px 0px',width:'20vw', minHeight:'11vh',maxHeight:'11vh'}} src={flora_icon_img} alt='' width={'67vw'} height={'67vh'} ></img>
        </div>
    </>
  )
}

const Screen2 = (props:{setScreenSelected:any,apicall:any,sender:any}) =>
{
  return(
    <>
      <div  style={{position:'absolute',left:'11vw',top:'7vh', backgroundColor:'#FFFFFF',cursor:'pointer',minHeight:'83vh',minWidth:'78vw',maxHeight:'83vh',maxWidth:'23vw', borderRadius:'3vw',boxShadow:'0px 0px 3px 0px black',backgroundImage:"url(" + flora_gif_img + ")",backgroundSize:'cover',backgroundRepeat:'no-repeat'}}>
<div style={{position:'relative',backgroundColor:'#0d0d0d',color:'white',width:'58vw',letterSpacing:'-0.015em',margin:'auto',padding:'3vw',fontSize:'4vw',fontFamily:'roboto',borderRadius:'3vw',marginTop:'55.5vh',minHeight:'7vh',lineHeight:1.5,textAlign:'justify'}}>{'Hi, I am Flora 👋 Welcome to Credo Health! To know more about Credo'}</div>
<div style={{position:'relative',background:'linear-gradient(180deg, #FF6702 0%, #FF9D5D 100%)',color:'white',width:'37.5vw',letterSpacing:'-0.015em',margin:'auto',padding:'3vw',fontSize:'4vw',fontFamily:'roboto',borderRadius:'3vw',marginTop:'2vh',textAlign:'center',minHeight:'3.3vh',display:'flex',alignItems:'center',justifyContent:'center'}} onClick={()=>{ props.setScreenSelected(6);props.apicall('/newuser',props.sender,null,'Hi Flora, I am a Visitor')}} >{'Ask Flora'}</div>
</div>
<MessageIcon/>
    </>

  )
}

const Screen3 = (props:{setScreenSelected:any,setVisitorStatus:any, apicall:any,sender:any}) =>
{
  const [visitorClick, setVisitorClick] = useState(0)
  return(
    <>
    <div  style={{position:'absolute',left:'11vw',top:'7vh', backgroundColor:'#FFFFFF',cursor:'pointer',minHeight:'83vh',minWidth:'78vw',maxHeight:'83vh',maxWidth:'23vw', borderRadius:'3vw',boxShadow:'0px 0px 5px 0px black',}}>
    <NavHeader {...props}/>
    <div style={{backgroundColor:'rgb(251, 231, 230)',color:'black',borderRadius:'3vw 3vw 3vw 3vw',fontFamily:'roboto',fontSize:'4vw',padding:'3vw',maxWidth:'55vw',margin:'auto',marginBottom:'3vh',minHeight:'4.5vw',marginTop:'0vh',lineHeight:1.5,textAlign:'justify'}}>
    Glad to meet you! To know more about Credo Health, please select one of the options below
</div> 
<style>
{
`
.s3:hover {
 background-color:#FA7837;
}
`
}
</style>
<div onClick={()=>{props.setScreenSelected(6);props.setVisitorStatus(1);props.apicall('/newuser',props.sender,null,'Hi Flora, I am New Visitor')}} onMouseEnter={()=>setVisitorClick(1)} onMouseLeave={()=>setVisitorClick(0)} style={{backgroundColor:'#e7f1fe', border:'3px solid #FFE8D6',color:'#212226',borderRadius:'3vw 3vw 3vw 3vw',fontFamily:'roboto',fontSize:'4vw',padding:'1vw',width:'59.5vw',marginLeft:'8vw',fontWeight:'400',minHeight:'8.5vh',display:'flex',flexDirection:'row',marginBottom:'3.5vh'}}>
   <div style={{marginLeft:'0.5vw',display:'flex',alignItems:'center',marginRight:'2vw',}}><img src={newvis_img} alt='' height='100%' width='110%'></img></div>
   <div  style={{marginLeft:'1vw',display:'flex',alignItems:'center',fontSize:'4vw',minWidth:'38vw'}}>I am a New Visitor</div>
   <div style={{boxSizing:'border-box',border:'2px solid #DADADA',minWidth:'20px',maxHeight:'20px',display:'flex',alignItems:'center',marginLeft:'auto',marginTop:'2.7vh',borderRadius:'3vw',marginRight:'1vw'}}>
   <div style={{minWidth:'2vw',minHeight:'1.6vh', maxHeight:'1.6vh',display:'flex',alignItems:'center',borderRadius:'1vw',backgroundColor:`${visitorClick===1?'#FA7837':'white'}`,position:'relative',color:'transparent',}}></div>
   </div>
</div>
<div  onClick={()=>{props.setScreenSelected(4);props.setVisitorStatus(2)}} onMouseEnter={()=>setVisitorClick(2)}  onMouseLeave={()=>setVisitorClick(0)}  style={{backgroundColor:'#e7f1fe', border:'3px solid #FFE8D6',color:'#212226',borderRadius:'3vw 3vw 3vw 3vw',fontFamily:'roboto',fontSize:'4vw',padding:'1vw',width:'59.5vw',marginLeft:'8vw',fontWeight:'400',minHeight:'8.5vh',display:'flex',flexDirection:'row',marginBottom:'3.5vh'}}>
   <div style={{marginLeft:'0.5vw',display:'flex',alignItems:'center',marginRight:'2vw'}}><img src={retvis_img} alt='' height='100%' width='110%'></img></div>
   <div  style={{marginLeft:'1vw',display:'flex',alignItems:'center',fontSize:'4vw',minWidth:'38vw'}}>I am a Returning Visitor</div>
   <div style={{boxSizing:'border-box',border:'2px solid #DADADA',minWidth:'20px',maxHeight:'20px',display:'flex',alignItems:'center',marginLeft:'auto',marginTop:'2.7vh',borderRadius:'3vw',marginRight:'1vw'}}>
   <div style={{minWidth:'2vw',minHeight:'1.6vh', maxHeight:'1.6vh',display:'flex',alignItems:'center',borderRadius:'1vw',backgroundColor:`${visitorClick===2?'#FA7837':'white'}`,position:'relative',color:'transparent',margin:'auto'}}></div>
   </div>
</div>
<div  onClick={()=>{props.setScreenSelected(4);props.setVisitorStatus(3)}} onMouseEnter={()=>setVisitorClick(3)}  onMouseLeave={()=>setVisitorClick(0)}  style={{backgroundColor:'#e7f1fe', border:'3px solid #FFE8D6',color:'#212226',borderRadius:'3vw 3vw 3vw 3vw',fontFamily:'roboto',fontSize:'4vw',padding:'1vw',width:'59.5vw',marginLeft:'8vw',fontWeight:'400',minHeight:'8.5vh',display:'flex',flexDirection:'row',marginBottom:'3.5vh'}}>
   <div style={{marginLeft:'0.5vw',display:'flex',alignItems:'center',marginRight:'2vw'}}><img src={credomem_img} alt='' height='100%' width='110%'></img></div>
   <div  style={{marginLeft:'1vw',display:'flex',alignItems:'center',fontSize:'4vw',minWidth:'38vw'}}>I am a Credo Member</div>
   <div style={{boxSizing:'border-box',border:'2px solid #DADADA',minWidth:'20px',maxHeight:'20px',display:'flex',alignItems:'center',marginLeft:'auto',marginTop:'2.7vh',borderRadius:'3vw',marginRight:'1vw'}}>
   <div style={{minWidth:'2vw',minHeight:'1.6vh', maxHeight:'1.5vh',display:'flex',alignItems:'center',borderRadius:'1vw',backgroundColor:`${visitorClick===3?'#FA7837':'white'}`,position:'relative',color:'transparent',margin:'auto',}}></div>
   </div>
</div>
</div>
  <MessageIcon/>
</>

  )
}

const Screen4 = (props:{setScreenSelected:any,setVisitorStatus:any,visitorStatus:any,setVisitorEmail:any,setVisitorPhoneNo:any,visitorEmail:any,visitorPhoneNo:any, apicall:any,sender:any}) =>
{
     var formdata={mail:props.visitorEmail,phone:props.visitorPhoneNo}
     function validate()
     {
      if(formdata.phone.length!==10){alert('Enter Valid Phone Number')}
      else{
        props.setScreenSelected(props.visitorStatus===2?5:6);
        if(props.visitorStatus===3){props.apicall('/credomem_no',props.sender,formdata,'Hi Flora, I am Credo Member')}
        if(props.visitorStatus===2){props.apicall('/returnuser',props.sender,formdata,'Hi Flora, I am Returning Visitor')}
      }
     }
  return(
    <>
       <div  style={{position:'absolute',left:'11vw',top:'7vh', backgroundColor:'#FFFFFF',cursor:'pointer',minHeight:'83vh',minWidth:'78vw',maxHeight:'83vh',maxWidth:'23vw', borderRadius:'3vw',boxShadow:'0px 0px 3px 0px black',}}>
       <NavHeader {...props}/>
<div style={{fontFamily:'roboto',fontWeight:'400',fontSize:'4vw',margin:'auto',maxWidth:'70vw',marginBottom:'5vh',marginTop:'0vh',lineHeight:1.5}}>
Hi there 👋  Please enter your contact number or email ID registered with us 
</div>
<div style={{boxShadow:'1px 2px 14px rgba(182, 182, 182, 0.36)',maxWidth:'70vw',minHeight:'30vh', backgroundColor:'white',margin:"auto",position:'relative',bottom:'3vh',display:'flex',flexDirection:'column'}}>
<div style={{fontSize:'4vw',fontFamily:'roboto',marginLeft:'1vw',marginRight:'1vw',marginTop:'5vw',marginBottom:'0.5vw',fontWeight:'400',display:`${props.visitorStatus===2?'block':'none'}`}}>Email</div>
<div><input onChange={(e:any)=>props.setVisitorEmail(e.target.value)} style={{borderRadius:'2vw',border:'2px solid #DDDDDD',margin:'auto',minWidth:'60vw',marginLeft:'1vw',marginRight:'1vw',minHeight:'5vh',fontFamily:'roboto',fontWeight:'400',fontSize:'4vw',paddingLeft:'2vw',display:`${props.visitorStatus===2?'block':'none'}`}}  placeholder='user@gmail.com'></input></div>
<div style={{fontSize:'4vw',fontFamily:'roboto',marginLeft:'1vw',marginRight:'1vw',marginTop:'5vw',marginBottom:'0.5vw',fontWeight:'400',}}>Phone Number</div>
<div><input  onChange={(e:any)=>props.setVisitorPhoneNo(e.target.value)} style={{borderRadius:'2vw',border:'2px solid #DDDDDD',margin:'auto',minWidth:'60vw',marginLeft:'1vw',marginRight:'1vw',minHeight:'5vh',fontFamily:'roboto',fontWeight:'400',fontSize:'4vw',paddingLeft:'2vw'}} placeholder='+91'></input></div>
</div>
<div onClick={validate}   style={{background:'rgb(229, 92, 0)',color:'white',maxWidth:'18.9vw',margin:'auto',textAlign:'center',fontSize:'4vw',padding:'0.6vw',borderRadius:'2vw',minHeight:'3.2vh',display:'flex',alignItems:'center',justifyContent:'center'}}>
SAVE
</div>
</div>
       <MessageIcon/>
    </>

  )
}

const Screen5 = (props:{setScreenSelected:any,setTextInput:any,textInput:any,compArr:any,apicall:any,sender:any}) =>
{
  return(
    <>
    <div  style={{position:'absolute',left:'11vw',top:'7vh', backgroundColor:'#FFFFFF',cursor:'pointer',minHeight:'83vh',minWidth:'78vw',maxHeight:'83vh',maxWidth:'23vw', borderRadius:'3vw',boxShadow:'0px 0px 5px 0px black',}}>
    <NavHeader {...props} />
<div style={{backgroundColor:'rgb(251, 231, 230)',color:'black',borderRadius:'1vw 1vw 1vw 0vw',fontFamily:'roboto',fontSize:'4vw',padding:'4vw',maxWidth:'58vw',margin:'auto',minHeight:'6.5vh',marginTop:'0vh',lineHeight:1.5,textAlign:'justify'}}>
{typeof(props.compArr[1])==='undefined'?'Fetching Data.. Please Wait..':props.compArr[1]['props']['children'][1]['props']['bot']}
</div>
<div  onClick={()=>{props.setScreenSelected(6);}} style={{backgroundColor:'rgb(229, 92, 0)',color:'white',borderRadius:'2vw 2vw 2vw 2vw',fontFamily:'roboto',fontSize:'4vw',padding:'1vw',maxWidth:'47.8vw',fontWeight:'400',textAlign:'center',border:`${'1px solid #FA7837'}`,margin:'auto',marginTop:'4vh',minHeight:'2.5vh',display:'flex',alignItems:'center',justifyContent:'center'}}>
Yes. Lets Continue
</div>
<div onClick={()=>{props.setScreenSelected(6);props.apicall('/livesupport',props.sender,null,'Requesting Live Support')}} style={{backgroundColor:'white',color:'black',borderRadius:'2vw 2vw 2vw 2vw',fontFamily:'roboto',fontSize:'4vw',padding:'1vw',maxWidth:'57.8vw',fontWeight:'400',textAlign:'center',border:`${'1px solid grey'}`,margin:'auto',marginTop:'4vh',lineHeight:1.5,display:'flex',alignItems:'center',justifyContent:'center'}}>
No, I would like to talk to a Human Counsellor
</div>
</div>
<MessageIcon/>
</>
  )
}
const Screen6 = (props:{setScreenSelected:any,setTextInput:any,textInput:any,compArr:any,apicall:any,multiButton:any,setMultiButton:any,sender:any}) =>
{
  return(
    <>
               <div  style={{position:'absolute',left:'11vw',top:'7vh', backgroundColor:'#FFFFFF',cursor:'pointer',minHeight:'83vh',minWidth:'78vw',maxHeight:'83vh',maxWidth:'23vw', borderRadius:'3vw',boxShadow:'0px 0px 5px 0px black',}}>
               <NavHeader {...props} />
 <div className='scroller' style={{backgroundColor:'white',margin:'auto', marginTop:'-0.5vh',  display:'flex',flexDirection:'column-reverse',}}>
 <div>
      <div style={{display:'flex',flexDirection:'column',flexFlow:'column nowrap'}}>
        <input type='text' onChange={(e)=>props.setTextInput(e.target.value)} style={{maxWidth:'100px',display:'none'}}></input>
        <button onClick={()=>props.apicall(props.textInput,props.sender)} style={{maxWidth:'50px',display:'none'}}>send</button>
        {props.compArr.map(function(item:any,i:any){return <div key={i}>{item}</div>})}
        <br/>
      </div>
    </div>
</div>
</div>
       <MessageIcon/>
       <style>
    {
        `
        .scroller {
            min-width: 70vw;
            max-width: 70vw;
            min-height: 61vh;
            max-height: 61vh;
            overflow-y: scroll;
          }

          /* width */
::-webkit-scrollbar {
  width: 2vw;
}
/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #b3b3b3; 
  border-radius: 2vw;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #D9D9D9; 
  border-radius: 2vw;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #bfbfbf; 
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.buttonuni {
	background-color: white;
    color:black;
}
.buttonuni:hover {
	background-color: #ff6700;
    color:white;
}
.animyes{
    animation: cssAnimation1 0s 0.5s forwards;
    opacity: 0.1;
}
.animyesbutton{
    animation: cssAnimation1 0s 1s forwards;
    opacity: 0.1;
}
@keyframes cssAnimation1 {
    to   {  opacity: 1;}
  }
        `
    }
</style>
    </>

  )
}
export default Mobile;